import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Box, Divider, Flex, MenuItem, mode, Text, useColorMode } from '@abb/uikit';
import { Check } from '@abb/uikit/icons/solid/general';
import { useCustomers, useDependencies, useSetToken } from 'hooks';
import React from 'react';
import { CustomersModal } from './customers-modal';
export const Customers = ()=>{
    const { userService } = useDependencies();
    const userData = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    const { data } = useCustomers();
    const { trigger } = useSetToken();
    const { colorMode } = useColorMode();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            (data === null || data === void 0 ? void 0 : data.length) > 3 ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(MenuItem, {
                        _hover: {
                            bg: mode('#FAFAFA', '#292B2E')({
                                colorMode
                            })
                        },
                        borderRadius: "12px",
                        p: "12px",
                        children: /*#__PURE__*/ _jsxs(Flex, {
                            w: "100%",
                            alignItems: "center",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsxs(Flex, {
                                    alignItems: "center",
                                    gap: 3,
                                    children: [
                                        /*#__PURE__*/ _jsx(Avatar, {
                                            size: "sm",
                                            name: userData === null || userData === void 0 ? void 0 : userData.customers[0].name
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            width: "155px",
                                            textTransform: "none",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            children: userData === null || userData === void 0 ? void 0 : userData.customers[0].name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Check, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(CustomersModal, {
                        data: data
                    })
                ]
            }) : data === null || data === void 0 ? void 0 : data.map((item)=>/*#__PURE__*/ _jsx(MenuItem, {
                    p: "12px",
                    borderRadius: "12px",
                    cursor: "pointer",
                    _hover: {
                        bg: mode('#FAFAFA', '#292B2E')({
                            colorMode
                        })
                    },
                    onClick: ()=>trigger({
                            cif: item.cif
                        }),
                    padding: "10px",
                    children: /*#__PURE__*/ _jsxs(Flex, {
                        align: "center",
                        justifyContent: "space-between",
                        w: "100%",
                        children: [
                            /*#__PURE__*/ _jsxs(Flex, {
                                textTransform: "none",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                alignItems: "center",
                                gap: 3,
                                _hover: {
                                    backgroundColor: 'none'
                                },
                                color: mode('#2D3748', '#F0F0F0')({
                                    colorMode
                                }),
                                children: [
                                    /*#__PURE__*/ _jsx(Avatar, {
                                        size: "sm",
                                        fontSize: "12px",
                                        name: item.name
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        width: "155px",
                                        textTransform: "none",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        children: item.name
                                    })
                                ]
                            }),
                            (userData === null || userData === void 0 ? void 0 : userData.customers[0].name) === item.name && /*#__PURE__*/ _jsx(Check, {})
                        ]
                    })
                }, item.cif)),
            /*#__PURE__*/ _jsx(Box, {
                px: 2,
                mt: "2px",
                children: /*#__PURE__*/ _jsx(Divider, {
                    color: mode('#8b96a93b', '#8b96a93b')({
                        colorMode
                    })
                })
            })
        ]
    });
};
